import React from "react";

const items = [
  "HIGH-TICKET CLOSING",
  "UDEVA · VOICE & ACCENT",
  "SCIENCE OF SALES",
  "BRAND BUILDING",
  "PITCH READY",
  "CORPORATE TIE-UPS",
  "ENGLISH BUILDERS",
  "REVENUE ENGINEERING"
];

export default function Marquee() {
  return (
    <div className="relative border-y border-white/5 bg-[#0a0a0b] overflow-hidden py-6">
      <div className="gt-marquee whitespace-nowrap">
        {[...items, ...items].map((t, i) => (
          <div key={i} className="flex items-center gap-12 shrink-0">
            <span className="gt-serif text-2xl md:text-3xl text-neutral-500">{t}</span>
            <span className="w-2 h-2 rounded-full bg-emerald-400" />
          </div>
        ))}
      </div>
    </div>
  );
}
